import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
    FormTitle, FormSubtitle, FormGroup, FormRow, Label,
    StyledInput, StyledSelect, ErrorText, RequiredBadge,
    CORRIDORS, TRANSFER_VOLUMES, SOURCE_OF_FUNDS, INTENDED_USE,
    TRANSACTION_TYPES, TRANSACTION_FREQUENCIES, AVERAGE_BALANCES
} from '../styles';

const Step2ComplianceActivity = () => {
    const { register, formState: { errors } } = useFormContext();

    return (
        <div>
            <FormTitle>Compliance & Account Purpose</FormTitle>
            <FormSubtitle>Transfer activities, regulatory standing, and intended account usage (required for BSA/AML compliance).</FormSubtitle>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="operatingCorridors">Primary Target Corridors<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('operatingCorridors')} $error={!!errors.operatingCorridors}>
                        <option value="">Select main corridor</option>
                        {CORRIDORS.map(cor => <option key={cor} value={cor}>{cor}</option>)}
                    </StyledSelect>
                    {errors.operatingCorridors && <ErrorText>{errors.operatingCorridors.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="monthlyTransferVolume">Expected Monthly Fx/Transfer Volume<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('monthlyTransferVolume')} $error={!!errors.monthlyTransferVolume}>
                        <option value="">Select volume</option>
                        {TRANSFER_VOLUMES.map(vol => <option key={vol} value={vol}>{vol}</option>)}
                    </StyledSelect>
                    {errors.monthlyTransferVolume && <ErrorText>{errors.monthlyTransferVolume.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormGroup>
                <Label htmlFor="amlPolicyStatus">AML / KYC Policy Status<RequiredBadge>*</RequiredBadge></Label>
                <StyledSelect {...register('amlPolicyStatus')} $error={!!errors.amlPolicyStatus}>
                    <option value="">Select status</option>
                    <option value="implemented_internal">We have a fully implemented internal policy</option>
                    <option value="implemented_third_party">We use a third-party provider (e.g., Jumio, Onfido)</option>
                    <option value="in_development">In development</option>
                </StyledSelect>
                {errors.amlPolicyStatus && <ErrorText>{errors.amlPolicyStatus.message}</ErrorText>}
            </FormGroup>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="sourceOfFunds">Source of Funds<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('sourceOfFunds')} $error={!!errors.sourceOfFunds}>
                        <option value="">Select source</option>
                        {SOURCE_OF_FUNDS.map(s => <option key={s} value={s}>{s}</option>)}
                    </StyledSelect>
                    {errors.sourceOfFunds && <ErrorText>{errors.sourceOfFunds.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="intendedUse">Intended Use of Account<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('intendedUse')} $error={!!errors.intendedUse}>
                        <option value="">Select intended use</option>
                        {INTENDED_USE.map(u => <option key={u} value={u}>{u}</option>)}
                    </StyledSelect>
                    {errors.intendedUse && <ErrorText>{errors.intendedUse.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="transactionTypes">Primary Transaction Types<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('transactionTypes')} $error={!!errors.transactionTypes}>
                        <option value="">Select type</option>
                        {TRANSACTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </StyledSelect>
                    {errors.transactionTypes && <ErrorText>{errors.transactionTypes.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="transactionFrequency">Expected Transaction Frequency<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('transactionFrequency')} $error={!!errors.transactionFrequency}>
                        <option value="">Select frequency</option>
                        {TRANSACTION_FREQUENCIES.map(f => <option key={f} value={f}>{f}</option>)}
                    </StyledSelect>
                    {errors.transactionFrequency && <ErrorText>{errors.transactionFrequency.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="averageBalance">Expected Average Balance<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('averageBalance')} $error={!!errors.averageBalance}>
                        <option value="">Select range</option>
                        {AVERAGE_BALANCES.map(b => <option key={b} value={b}>{b}</option>)}
                    </StyledSelect>
                    {errors.averageBalance && <ErrorText>{errors.averageBalance.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormGroup>
                <Label htmlFor="primaryUseCases">Primary Use Cases for NYBANQ <span style={{ opacity: 0.6, fontWeight: 'normal' }}>— Optional</span></Label>
                <StyledInput
                    as="textarea"
                    rows="4"
                    {...register('primaryUseCases')}
                    placeholder="e.g. B2B payouts to suppliers, remittance processing..."
                    style={{ resize: 'vertical', minHeight: '100px' }}
                />
            </FormGroup>

            <FormGroup>
                <Label htmlFor="website">Institution Website <span style={{ opacity: 0.6, fontWeight: 'normal' }}>— Optional</span></Label>
                <StyledInput type="url" {...register('website')} placeholder="https://www.examplebank.com" $error={!!errors.website} />
                {errors.website && <ErrorText>{errors.website.message}</ErrorText>}
            </FormGroup>
        </div>
    );
};

export default Step2ComplianceActivity;
